import { resolveValue, Toaster as RHTToaster } from 'react-hot-toast';
import { cn } from '~/lib/utils';
import Alert from './Alert';

function Toaster() {
  return (
    <RHTToaster position="bottom-left" toastOptions={{ duration: 3000 }}>
      {(t) => (
        <div
          className={cn(
            { 'animate-enter': t.visible, 'animate-leave': !t.visible },
            'max-w-md w-full shadow-lg pointer-events-auto',
          )}
        >
          <Alert variant={t.type} description={resolveValue(t.message, t)} className="w-full" />
        </div>
      )}
    </RHTToaster>
  );
}

export default Toaster;
